module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "software"
  }, [_c('Item')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e2a43e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Software/Index.vue
// module id = 974
// module chunks = 0